<template>
  <el-dialog
    :visible.sync="dialogVisible"
    title="上传底图"
    width="560px"
    :close-on-click-modal="false"
    @closed="resetForm"
  >
    <el-form ref="formRef" :model="formData" :rules="rules" label-width="120px" size="mini">
      <el-form-item label="店铺" prop="storeId">
        <el-select
          v-model="formData.storeId"
          placeholder="请选择店铺"
          style="width: 100%"
          @change="handleStoreChange"
        >
          <el-option
            v-for="item in storeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item label="选择模板" prop="templateId">
        <template-select
          v-model="formData.templateId"
          :store-id="formData.storeId"
          @change="handleTemplateChange"
        />
      </el-form-item>

      <el-form-item label="模板底图分辨率" prop="resolution">
        <el-input v-model="formData.resolution" readonly />
      </el-form-item>

      <el-form-item label="上传方式" prop="uploadMode">
        <el-radio-group v-model="formData.uploadMode">
          <el-radio label="add">新增</el-radio>
          <el-radio label="replace">替换</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="选择图片" prop="files">
        <el-upload
          action=""
          :auto-upload="false"
          multiple
          :show-file-list="true"
          :file-list="fileList"
          accept=".jpg,.jpeg,.png"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
        >
          <el-button size="mini" type="primary">上传本地图片</el-button>
          <div slot="tip" class="el-upload__tip">支持多选，仅支持 JPG、PNG 格式</div>
        </el-upload>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button size="mini" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" size="mini" @click="handleConfirm">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import mockService from '../../mockService'
import TemplateSelect from './TemplateSelect.vue'

export default {
  name: 'ActivityBaseUploadDialog',
  components: {
    TemplateSelect
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      storeOptions: [],
      fileList: [],
      uploadedImageSize: null,
      formData: {
        storeId: '',
        templateId: '',
        templateName: '',
        resolution: '',
        uploadMode: 'add'
      },
      rules: {
        storeId: [
          { required: true, message: '请选择店铺', trigger: 'change' }
        ],
        templateId: [
          { required: true, message: '请选择模板', trigger: 'change' }
        ],
        resolution: [
          { validator: this.validateResolution, trigger: 'change' }
        ],
        uploadMode: [
          { required: true, message: '请选择上传方式', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.initOptions()
      }
    }
  },
  methods: {
    validateResolution (rule, value, callback) {
      if (!value) {
        callback(new Error('请选择模板'))
        return
      }
      if (!this.uploadedImageSize) {
        callback()
        return
      }
      const match = String(value).match(/(\d+)\s*x\s*(\d+)/i)
      if (!match) {
        callback(new Error('请上传与分辨率一样的图片'))
        return
      }
      const width = Number(match[1])
      const height = Number(match[2])
      if (width !== this.uploadedImageSize.width || height !== this.uploadedImageSize.height) {
        callback(new Error('请上传与分辨率一样的图片'))
        return
      }
      callback()
    },
    initOptions () {
      mockService.getStoreOptions().then(res => {
        this.storeOptions = res.data || []
      })
    },
    handleStoreChange () {
      this.formData.templateId = ''
      this.formData.templateName = ''
      this.formData.resolution = ''
      this.uploadedImageSize = null
    },
    handleTemplateChange ({ option }) {
      this.formData.templateName = option.templateName || ''
      this.formData.resolution = option.resolution || ''
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validateField('resolution')
        }
      })
    },
    handleFileChange (file, fileList) {
      const name = (file.raw && file.raw.name) || file.name || ''
      const ext = name.substring(name.lastIndexOf('.') + 1).toLowerCase()
      if (['jpg', 'jpeg', 'png'].indexOf(ext) === -1) {
        this.$message.error('仅支持 JPG、PNG 格式')
        this.fileList = fileList.filter(item => {
          const currentName = (item.raw && item.raw.name) || item.name || ''
          const currentExt = currentName.substring(currentName.lastIndexOf('.') + 1).toLowerCase()
          return ['jpg', 'jpeg', 'png'].includes(currentExt)
        })
        this.uploadedImageSize = null
        return
      }
      this.fileList = fileList
      const latestFile = fileList[fileList.length - 1]
      const rawFile = (latestFile && (latestFile.raw || latestFile)) || (file.raw || file)
      const objectUrl = window.URL.createObjectURL(rawFile)
      const image = new Image()
      image.onload = () => {
        this.uploadedImageSize = {
          width: image.width,
          height: image.height
        }
        window.URL.revokeObjectURL(objectUrl)
        this.$nextTick(() => {
          if (this.$refs.formRef) {
            this.$refs.formRef.validateField('resolution')
          }
        })
      }
      image.onerror = () => {
        this.uploadedImageSize = null
        window.URL.revokeObjectURL(objectUrl)
      }
      image.src = objectUrl
    },
    handleFileRemove (file, fileList) {
      this.fileList = fileList
      this.uploadedImageSize = null
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.validateField('resolution')
        }
      })
    },
    handleConfirm () {
      this.$refs.formRef.validate(valid => {
        if (!valid) return
        if (!this.fileList.length) {
          this.$message.error('请先选择图片')
          return
        }
        const store = this.storeOptions.find(item => item.value === this.formData.storeId) || {}
        this.$emit('confirm', {
          storeId: this.formData.storeId,
          storeName: store.label || '',
          templateId: this.formData.templateId,
          templateName: this.formData.templateName,
          resolution: this.formData.resolution,
          uploadMode: this.formData.uploadMode,
          files: this.fileList.map(item => (item.raw ? item : { raw: item }))
        })
      })
    },
    resetForm () {
      this.formData = {
        storeId: '',
        templateId: '',
        templateName: '',
        resolution: '',
        uploadMode: 'add'
      }
      this.fileList = []
      this.uploadedImageSize = null
      if (this.$refs.formRef) {
        this.$refs.formRef.clearValidate()
      }
    }
  }
}
</script>
